import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// Best-effort gizlilik koruması: pencere odaktan çıkınca/uygulama değişince içeriği gizler,
// PrintScreen'de panoyu temizler, yazdırma/kaydetmeyi ve sağ tık menüsünü engeller.
// Not: Web tarayıcıları işletim sistemi düzeyinde ekran görüntüsünü tamamen engelleyemez;
// bu katman caydırıcıdır ve önizleme/kayıt sırasında içeriği maskeler.
export default function ScreenshotGuard() {
  const [hidden, setHidden] = useState(false);
  const lastLog = useRef({});

  useEffect(() => {
    const report = (method) => {
      const now = Date.now();
      if (now - (lastLog.current[method] || 0) < 10000) return; // 10 sn kısıt
      lastLog.current[method] = now;
      api.post("/audit/screenshot-attempt", { method, page: window.location.pathname }).catch(() => {});
    };

    const style = document.createElement("style");
    style.setAttribute("data-ssg", "1");
    style.textContent = "@media print { body { display: none !important; } }";
    document.head.appendChild(style);

    const onVis = () => setHidden(document.visibilityState !== "visible");
    const onBlur = () => setHidden(true);
    const onFocus = () => setHidden(false);
    const onCtx = (e) => e.preventDefault();
    const clearClip = () => { try { navigator.clipboard && navigator.clipboard.writeText("").catch(() => {}); } catch (_) { /* noop */ } };
    const onKey = (e) => {
      const k = (e.key || "").toLowerCase();
      if (k === "printscreen") {
        clearClip();
        setHidden(true);
        report("printscreen");
        setTimeout(() => setHidden(false), 1200);
      }
      if ((e.ctrlKey || e.metaKey) && (k === "p" || k === "s")) {
        e.preventDefault();
        if (e.type === "keydown") report(k === "p" ? "print" : "save");
      }
    };

    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("blur", onBlur);
    window.addEventListener("focus", onFocus);
    document.addEventListener("contextmenu", onCtx);
    window.addEventListener("keyup", onKey);
    window.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("contextmenu", onCtx);
      window.removeEventListener("keyup", onKey);
      window.removeEventListener("keydown", onKey);
      style.remove();
    };
  }, []);

  if (!hidden) return null;
  return (
    <div
      data-testid="screenshot-guard-overlay"
      style={{
        position: "fixed", inset: 0, zIndex: 999999, background: "#0F2C59",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "white", textAlign: "center", padding: 24,
      }}
    >
      <div>
        <p style={{ fontWeight: 700, fontSize: 18 }}>Gizlilik Koruması</p>
        <p style={{ fontSize: 13, opacity: 0.8, marginTop: 8 }}>
          İçerik pencere odaktan çıkınca gizlenir. Ekran görüntüsü/kayıt için içerik maskelenmiştir.
        </p>
      </div>
    </div>
  );
}
